export default __webpack_public_path__ + "static/media/635.db35fbc0.png";